import get from 'lodash/get';

export const getSuccessOverlay = state => get(state, 'successOverlay.successOverlay', null);
export const getParamEmailProvider = state => get(state, 'successOverlay.params.doi.emailProvider', null);
export const getParamSendingConfirmationEmail = state => get(state, 'successOverlay.params.doi.sendingConfirmationEmail', false);
export const getAlert = state => get(state, 'successOverlay.alert', null);
